<template>
  <div class="download-card">
    <div class="download-card__info">
      <div
        class="download-card__title"
        v-tooltip:top="title"
      >
        {{ title }}
      </div>
      <div class="download-card__description">{{ modelType }}</div>
    </div>
    <button
      v-if="showRunModel"
      v-tooltip:top="'Run Model'"
      type="button"
      class="download-card__action"
      aria-label="Run Model"
      @click="emit('run-model')"
    >
      <SVGIcon
        :iconName="'play'"
        :width="'18px'"
        :height="'18px'"
      />
    </button>
    <button
      v-tooltip:top="`Download:  ${title}`"
      type="button"
      class="download-card__action"
      aria-label="Download"
      @click="emit('download')"
    >
      <SVGIcon
        :iconName="'arrow_upward'"
        :width="'18px'"
        :height="'18px'"
        :mirrored="true"
      />
    </button>
  </div>
</template>

<script setup>
import SVGIcon from '@/components/SVGIcon.vue';

defineProps({
  title: { type: String, default: '' },
  modelType: { type: String, default: '' },
  showRunModel: { type: Boolean, default: false },
});

const emit = defineEmits(['download', 'run-model']);
</script>

<style scoped lang="scss">
.download-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #ffffff;
  transition: all 0.2s ease;
  width: 100%;
  max-width: 400px;

  &:hover {
    border-color: #0066cc;
    box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
    color: #0066cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__description {
    font-size: 12px;
    color: #666666;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    margin-left: 8px;
    padding: 0;
    border: 1px solid $color-primary;
    border-radius: 50%;
    background: #fff;
    color: $color-primary;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  &__action:hover {
    background: $color-primary;
    color: #fff;
  }
}
</style>
